import clsx from "clsx";
import ConditionalWrapper from "components/ConditionalWrapper";
import Link from "next/link";
import Balancer from "react-wrap-balancer";

const Heading = ({
  heading = "",
  link = { linkHref: null, linkAs: null },
  style = "normal",
  hoverAnimation,
  subHeading = null,
  backgroundColor = "#ffffff",
  textColor = "#000000",
  spaceAbove = null,
  spaceBelow = null,
}) => {
  const className = clsx(
    "Heading",
    `Heading--style--${style || "normal"}`,
    `Heading--hoverAnimation--${hoverAnimation || "none"}`,
    { [`Heading--spaceAbove--${spaceAbove}`]: !!spaceAbove },
    { [`Heading--spaceBelow--${spaceBelow}`]: !!spaceBelow },
    { "Heading--withSubHeading": !!subHeading }
  );

  return (
    (<div className={className} style={{ backgroundColor, color: textColor }}>
      <div className={clsx("Heading__content", "space-y-2")}>
        {heading && (
          <ConditionalWrapper
            condition={style !== "border"}
            wrapper={(children) => (
              <h2 className="Heading__heading">{children}</h2>
            )}
            alternativeWrapper={(children) => (
              <h3 className="Heading__heading">{children}</h3>
            )}
          >
            {link.linkHref && (
              <Link
                href={link.linkHref}
                as={link.linkAs}
                className="Heading__link"
                style={{
                  borderColor: style === "border" ? textColor : null,
                }}>

                {heading}

              </Link>
            )}
            {!link.linkHref && (
              <span className={clsx("Heading__label", "heading-lg--spatial")}>
                {heading}
              </span>
            )}
          </ConditionalWrapper>
        )}
        {subHeading && (
          <Balancer
            className={clsx(
              "Heading__subHeading",
              "mx-auto max-w-xl text-center font-body text-base text-zinc-500"
            )}
          >
            {subHeading}
          </Balancer>
        )}
      </div>
    </div>)
  );
};

export default Heading;
